(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("VIN", function () {
    /*
     * This is a simple VIN matching pattern.
     * It allows any alphanumeric characters except: I, O, and Q
     */
    var pattern = /^[A-HJ-NPR-Za-hj-npr-z0-9]{17}$/;

    return {
      isValid: function (vin) {
        return pattern.test(vin);
      },
    };
  });
})(window.angular);
